import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PortfolioService from '../../services/portfolio.service'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import moment from 'moment'
import { NeoLoader } from '../../components/FormComponents'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import StatementCard from './statement-card'
import { DETAILED_STATEMENT_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function LastTwoMonthStatement() {
  const accountDetails = useSelector(getCurrentAccDetailsSelector) || {}
  const [dataSource, setDataSource] = useState([])
  const [page, setPage] = useState(0)
  const [loader, setLoader] = useState(false)
  const {t}=useTranslation()

  useEffect(() => {
    getFullStatement()
  }, [])

  const getFullStatement = useCallback(async () => {
    try {
      setLoader(true)
      const response = await PortfolioService.getAccountFullStatement({
        accountNo: accountDetails.accountNo,
        brnCode: accountDetails.brnCode,
        fromDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        page: page,
      })
      if (response.status === 200) {
        setDataSource(response.data['items'])
        setLoader(false)
      }
    } catch (err) {
      console.log(err)
      setLoader(false)
    }
  }, [accountDetails, page])

  return (
    <LayoutWithAccountCard breadCumKey='LAST_TWO_MONTH'>
      <div className='row'>
        <div className='col-12 d-flex'>
          <div>
            <img src={StatementIcon} alt='statement icon' />
          </div>
          <div className="title-spacing">
            <span className='font-weight-bold'>{t(DETAILED_STATEMENT_KEYS.HEADER)}</span>
            <span className='header-title-section'>
              <p>{t(DETAILED_STATEMENT_KEYS.LAST_TWO_MONTH_DESC)}</p>
            </span>
          </div>
        </div>
      </div>

      {loader && <NeoLoader />}

      {!loader && dataSource.length === 0 && (
        <div className='text-center'>{t(DETAILED_STATEMENT_KEYS.NO_TRANSACTION_FOUND)}</div>
      )}

      {!loader && dataSource.length > 0 && (
        <StatementCard
          fromDate={moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')}
          toDate={moment().format('YYYY-MM-DD')}
          dataSource={dataSource}
        />
      )}
    </LayoutWithAccountCard>
  )
}
